// Простая функция санитизации. Подходит для простой санитизации регулярок с пользовательским вводом.
export function sanitizeMini(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}